import { MATISSE_BLUE, STORM_GREY } from "../../../constants/colors";

const activeColor = `${MATISSE_BLUE}`;
const inactiveColor = `${STORM_GREY}`;

export const fallbackValues = {
  activeColor,
  inactiveColor
};
